<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <h3 class="mb-4">Account activeren</h3>
                                <p>Er is zojuist een email met verdere instructies gestuurd naar:</p>
                                <b-alert variant="success" show>{{$route.query.email}}</b-alert>
                                <p></p>
                            </b-card-body>
                        </b-card>
                        <b-card bg-variant="dark" class="d-md-down-none d-flex align-items-center" style="background-image: url('/img/logo-rccs.svg'); background-repeat: no-repeat; background-size: 80% auto; background-position: center;"></b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'activate-account',
        data() {
            return {
                form: {
                    email: this.$route.query.email
                },
                message: null,
                success: false,
                loading: false,
            }
        },
        methods: {
            async passwordRequest() {
                this.loading = true;
                const request = await axios.post(process.env.VUE_APP_API_URL + '/api/forgot-password', this.form).catch(error => error.response);
                if (request.status !== 200) {
                    this.$router.push('/login');
                }
            }
        },
        beforeMount() {
            this.passwordRequest();
        }
    }
</script>
